export const colors = {
  dimoPrimary: "#023634",
  dimoDark: "#042C2B",
  dimoPop: "#0BFF80",
  dimoDark3: "#006865",
};